import { render, staticRenderFns } from "./_base-subCard.vue?vue&type=template&id=87d1190c&scoped=true"
import script from "./_base-subCard.vue?vue&type=script&lang=js"
export * from "./_base-subCard.vue?vue&type=script&lang=js"
import style0 from "./_base-subCard.vue?vue&type=style&index=0&id=87d1190c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d1190c",
  null
  
)

export default component.exports